export class AzureSapHanaResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instances",
            "baseName": "instances",
            "type": "Array<SapHanaInstance>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSapHanaResource.attributeTypeMap;
    }
    constructor() {
    }
}
